import { render, staticRenderFns } from "./JurnalList.vue?vue&type=template&id=fb5d9c60&"
import script from "./JurnalList.vue?vue&type=script&lang=js&"
export * from "./JurnalList.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/jqwidgets/jqx.base.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports